import datasetDatasourceActions, { datasetDatasourceFeatureActions } from './constants';

export const fetchDatasourceFeatures = (category, code) => ({
  category,
  code,
  type: datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES,
});

export const fetchDatasourceFeaturesError = (category, code, error) => ({
  category,
  code,
  error,
  type: datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES_ERROR,
});

export const fetchDatasourceFeaturesSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES_SUCCESS,
});

export const fetchDatasourceSettings = (category, code) => ({
  category,
  code,
  type: datasetDatasourceActions.FETCH_DATASOURCE_SETTINGS,
});

export const initialiseDatasourceSettings = (category, code) => ({
  category,
  code,
  type: datasetDatasourceActions.INITIALISE_DATASOURCE_SETTINGS,
});

export const fetchDatasourceSettingsError = (category, code, error) => ({
  category,
  code,
  error,
  type: datasetDatasourceActions.FETCH_DATASOURCE_SETTINGS_ERROR,
});

export const fetchDatasourceSettingsSuccess = (category, code, result, duplicate) => ({
  category,
  code,
  duplicate,
  result,
  type: datasetDatasourceActions.FETCH_DATASOURCE_SETTINGS_SUCCESS,
});

export const hideDatasourceSettings = (category, code) => ({
  category,
  code,
  type: datasetDatasourceActions.HIDE_DATASOURCE_SETTINGS,
});

export const showDatasourceSettings = (category, code, title) => ({
  category,
  code,
  title,
  type: datasetDatasourceActions.SHOW_DATASOURCE_SETTINGS,
});

export const updateDatasourceSettings = (category, code, properties) => ({
  category,
  code,
  properties,
  type: datasetDatasourceActions.UPDATE_DATASOURCE_SETTINGS,
});

export const saveDatasourceSettings = (category, code) => ({
  category,
  code,
  type: datasetDatasourceActions.SAVE_DATASOURCE_SETTINGS,
});

export const saveDatasourceSettingsSuccess = (category, code, name) => ({
  category,
  code,
  name,
  type: datasetDatasourceActions.SAVE_DATASOURCE_SETTINGS_SUCCESS,
});

export const saveDatasourceWizardSuccess = (category, code, name, templateChanged) => ({
  category,
  code,
  name,
  templateChanged,
  type: datasetDatasourceActions.SAVE_DATASOURCE_WIZARD_SUCCESS,
});

export const saveDatasourceWizardError = (category, code, error, name, templateChanged) => ({
  category,
  code,
  error,
  name,
  templateChanged,
  type: datasetDatasourceActions.SAVE_DATASOURCE_WIZARD_ERROR,
});

export const saveDatasourceSettingsError = (category, code, error) => ({
  category,
  code,
  error,
  type: datasetDatasourceActions.SAVE_DATASOURCE_SETTINGS_ERROR,
});

export const removeDatasourceSettings = (category, code, title, error) => ({
  category,
  code,
  error,
  title,
  type: datasetDatasourceActions.REMOVE_DATASOURCE_SETTINGS,
});

export const testDatasourceSettings = (category, code) => ({
  category,
  code,
  type: datasetDatasourceActions.TEST_DATASOURCE_SETTINGS,
});

export const testDatasourceSettingsSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: datasetDatasourceActions.TEST_DATASOURCE_SETTINGS_SUCCESS,
});

export const testDatasourceSettingsError = (category, code, error) => ({
  category,
  code,
  error,
  type: datasetDatasourceActions.TEST_DATASOURCE_SETTINGS_ERROR,
});

export const closeDatasourceSettings = () => ({
  type: datasetDatasourceActions.CLOSE_DATASOURCE_SETTINGS,
});

export const fetchDatasourceTypes = (category) => ({
  category,
  type: datasetDatasourceActions.FETCH_DATASOURCE_TYPES,
});

export const fetchDatasourceTypesError = (category, error) => ({
  category,
  error,
  type: datasetDatasourceActions.FETCH_DATASOURCE_TYPES_ERROR,
});

export const fetchDatasourceTypesSuccess = (category, result) => ({
  category,
  result,
  type: datasetDatasourceActions.FETCH_DATASOURCE_TYPES_SUCCESS,
});
